import { useState, useEffect } from 'react'
// import { toast } from 'react-toastify';

export const useFetchAllRates = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataRates, setDataRates] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllRates, setLoadingFetchAllRates ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-all-rates`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllRates(true)
        fetchData()
            .then((resp) => {
                setDataRates(resp.rows)
                setLoadingFetchAllRates(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllRates(false)
            })
    }, [execute])

    return { dataRates, loadingFetchAllRates, executeFetch }

}

export const useFetchSpecificRate = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificRate, setLoadingFetchSpecificRate ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idrate: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal/fetch-specific-rate/${paramsToSearch.idrate}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idrate > 0 ){
            setLoadingFetchSpecificRate(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idrate: rows[0].idrate || '',
                        descripcion: rows[0].descripcion || '',
                        costo: rows[0].costo || ''
                    }))
                    setLoadingFetchSpecificRate(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificRate(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificRate, setParamsToSearch, executeFetch }

}